module.exports = __webpack_public_path__ + "static/media/background_circle_green_modal.e318188c.svg";